export enum TypeClassSubscriptionForm {
  MY_SUBSCRIPTION = 'my-subscription',
  SUBSCRIPTION_MODAL = 'subscription-modal',
  DONATION = 'donation',
}
